import * as TYPE from "../../actions/ActionConstants";

const initialState = {
  loading: false,
  error: false,
  message: "",
  customers: [],
};

const dashBoardRecentCustomersReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPE.IS_FETCHING:
      return {
        ...state,
        error: false,
        message: "",
        loading: action.payload,
      };
    case TYPE.GET_RECENT_CUSTOMERS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: "Roles fetch successfully",
        customers: action.payload.data,
      };
    case TYPE.GET_RECENT_CUSTOMERS_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: "Error while fetching roles",
        customers: [],
      };

    case TYPE.USER_LOGOUT:
      return initialState;
    default:
      return state;
  }
};
export default dashBoardRecentCustomersReducer;
